import { render, staticRenderFns } from "./EmailStepAccount.vue?vue&type=template&id=2fb97518&scoped=true"
import script from "./EmailStepAccount.vue?vue&type=script&lang=js"
export * from "./EmailStepAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb97518",
  null
  
)

export default component.exports